module.exports = __webpack_public_path__ + "images/emoji/heavy_multiplication_x.321103fb90b5e4ecf9f7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/heavy_multiplication_x.png
// module id = pZ+F
// module chunks = 13